/**
 * @module components/statusbar/StatusBar
 * @summary Bottom status bar: cursor coords, counts, selection, active tool.
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 551-558.
 */
import { useUiStore } from '../../state/uiStore';

export function StatusBar() {
  const status = useUiStore((s) => s.status);
  return (
    <div id="statusbar">
      <span id="st-coords">
        X: {status.coordsX}&nbsp;&nbsp;Y: {status.coordsY}
      </span>
      <span id="st-count">
        Shapes: {status.shapeCount} | Conns: {status.connCount}
      </span>
      <span id="st-sel">{status.selLabel}</span>
      {/* On-screen credit only — exports render from off-screen canvases, so
          this never appears in PNG/PDF output. */}
      <span id="st-credit">Developed by Ibrahim Al-Osman — Process Engineer</span>
      <span id="st-tool">{status.tool.toUpperCase()}</span>
    </div>
  );
}
